import { useEffect } from 'react'
import PropTypes from 'prop-types'
import Type from 'components/Type'
import Stack from '@mui/material/Stack'
import { IconThumbsUpCircle } from 'icons'
import { useAction } from 'utils/actions'

const AllSet = props => {
  const { closeModal, closeDrawer } = useAction()

  useEffect(() => {
    const duration = props.duration || (props.subtitle ? 3000 : 1500)
    const timer = setTimeout(() => {
      if (!props.cancelTimeout) {
        props.onClose?.()
        closeModal()
        closeDrawer()
      }
    }, duration)
    return () => clearTimeout(timer)
  }, [])

  return (
    <Stack
      display="grid"
      gap={2}
      justifyItems="center"
      alignContent="center"
      py={3}
      px={{ xx: 2, xs: 3 }}
      minHeight="340px"
    >
      <IconThumbsUpCircle />
      <Stack display="grid" gap={1} justifyItems="center" textAlign="center">
        <Type variant="sectionLabel">
          {props.title || "You're all set!"}
        </Type>
        {props.subtitle && <Type variant="p">{props.subtitle}</Type>}
        {props.description && <Type variant="dataSmall" color="neutralCool_700">{props.description}</Type>}
      </Stack>
      {props.content}
    </Stack>
  )
}

AllSet.propTypes = {
  cancelTimeout: PropTypes.bool,
  title: PropTypes.any,
  subtitle: PropTypes.any,
  content: PropTypes.any,
  description: PropTypes.any,
  duration: PropTypes.number,
  onClose: PropTypes.func,
}

export default AllSet
